import React, { useState, useEffect } from 'react';
import { Search, Plus } from 'lucide-react';
import { getClientes } from '../api';
import ClienteModal from '../components/ClienteModal';

const ClientesList = () => {
  const [clientes, setClientes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchClientes = async () => {
    try {
      const res = await getClientes();
      setClientes(res.data);
    } catch (err) {
      console.error("Error al obtener clientes", err);
    }
  };

  useEffect(() => {
    fetchClientes();
  }, []);

  // Generar color basado en nombre para el avatar
  const getAvatarColor = (name) => {
    const colors = ['bg-red-400', 'bg-blue-400', 'bg-green-400', 'bg-yellow-400', 'bg-purple-400', 'bg-indigo-400'];
    const idx = name.length % colors.length;
    return colors[idx];
  };

  const getInitials = (name) => {
    const parts = name.split(' ');
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.substring(0, 2).toUpperCase();
  };

  const filtered = clientes.filter(c => c.nombre.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className="p-8 w-full max-w-7xl mx-auto flex flex-col h-full">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800 uppercase tracking-wider">Clientes</h1>
        <button 
          onClick={() => setIsModalOpen(true)}
          className="bg-[#00a99d] text-white px-4 py-2 rounded flex items-center gap-2 font-bold text-sm hover:bg-opacity-90 transition"
        >
          <Plus size={18} /> AGREGAR CLIENTE
        </button>
      </div>

      <div className="bg-white p-4 rounded-t-lg shadow-sm flex items-center border border-gray-200 border-b-0 w-full md:w-1/2">
        <label className="text-sm font-bold text-gray-500 mr-4">Filtrar:</label>
        <div className="flex-1 flex items-center border rounded px-3 py-1 text-gray-400 focus-within:border-emeral-green transition">
          <Search size={14} />
          <input 
            type="text" 
            placeholder="Cliente" 
            className="ml-2 outline-none w-full text-sm text-gray-700" 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <button className="bg-emeral-green p-2 rounded text-white ml-2"><Search size={16}/></button>
      </div>

      <div className="bg-white border rounded-lg rounded-tl-none shadow-sm overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-[#00a99d] text-white">
              <th className="p-3 text-xs font-bold uppercase tracking-wider pl-6">Nombre</th>
              <th className="p-3 text-xs font-bold uppercase tracking-wider">Teléfono</th>
              <th className="p-3 text-xs font-bold uppercase tracking-wider"># proc</th>
              <th className="p-3 text-xs font-bold uppercase tracking-wider">Último proceso</th>
              <th className="p-3 text-xs font-bold uppercase tracking-wider text-right pr-6">Acción</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {filtered.map(cliente => (
              <tr key={cliente.id} className="hover:bg-green-50 transition-colors">
                <td className="p-3 pl-6">
                  <div className="flex items-center gap-3">
                    <div className={`w-8 h-8 rounded shrink-0 flex items-center justify-center text-white font-bold text-xs ${getAvatarColor(cliente.nombre)}`}>
                      {getInitials(cliente.nombre)}
                    </div>
                    <span className="font-bold text-sm text-gray-800">{cliente.nombre}</span>
                  </div>
                </td>
                <td className="p-3 text-sm text-gray-500">{cliente.telefono}</td>
                <td className="p-3 text-sm font-bold text-gray-700">{cliente.procesosCount}</td>
                <td className="p-3 text-sm text-[#00a99d] hover:underline cursor-pointer">{cliente.ultimoProceso}</td>
                <td className="p-3 pr-6 text-right">
                  <button className="border border-gray-300 text-gray-600 bg-white hover:bg-gray-50 px-3 py-1 rounded text-xs font-bold shadow-sm transition">
                    Ver
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ClienteModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onRefresh={fetchClientes}
      />
    </div>
  );
};

export default ClientesList;
